// extracted by mini-css-extract-plugin
export default {"primaryBtnCustom":"upload-history-table_primaryBtnCustom__RWHBg","completedLoan":"upload-history-table_completedLoan__YRZ59"};